
// app/i18n/indexeddb-asset-translate-loader.ts
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { defer, from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getStoredPayload, storeDictionary } from './translation-storage';

export class IndexedDbAssetTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private assetsPath: string = '/assets/i18n'
  ) { }

  getTranslation(lang: string): Observable<any> {
    const assetUrl = `${this.assetsPath}/${lang}/test.json`;

    // Busca asset, persiste no IndexedDB e emite translations
    const fetchFromAssets$ = this.http.get<any>(assetUrl).pipe(
      switchMap((json) => {
        const version = json?.version ?? '0';
        const { _meta, ...translations } = json ?? {};
        return from(storeDictionary(lang, version, translations)).pipe(
          map(() => translations),
          // Se o storage falhar, não bloqueia a UI: emite translations mesmo assim
          catchError(() => of(translations))
        );
      })
    );

    // 1) Tenta IndexedDB
    return defer(() => from(getStoredPayload(lang))).pipe(
      switchMap((payload: any) => {
        if (!payload) return fetchFromAssets$;

        const localVersion = payload.version ?? '0';

        // 2) Compara versão local com a do asset; se igual, serve do IndexedDB
        return this.http.get<any>(assetUrl).pipe(
          map((json) => json?.version ?? '0'),
          catchError(() => of('0')),
          switchMap((assetVersion) =>
            localVersion === assetVersion ? of(payload) : fetchFromAssets$
          )
        );
      }),
      // Último recurso: se algo acima explodir, tenta o asset cru
      catchError(() =>
        this.http.get<any>(assetUrl).pipe(
          map((json) => {
            const { _meta, ...translations } = json ?? {};
            return translations;
          })
        )
      )
    );
  }


}
